import { render } from "./index.vue?vue&type=template&id=ec05088a"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
script.render = render

export default script